import { BasicProfileAction } from './constants';

const SALARY_TYPES = {
  HOURLY: 1,
  MONTHLY: 2
};

const initialState = {
  rate_config: null,
  rate_config_date: null,
  loading: false,
  fullName: '',
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  phoneCountry: '',
  salaryType: 3,
  jobRoles: [],
  country_id: '',
  gender: null,
  ref_checked_values: [],
  ref_other_value: null,
  country_citizenship_id: '',
  country_residence_code: null,
  country_citizenship_code: null,
  preferredStack: '',
  expected_salary: null,
  expected_salary_amount_yearly: null,
  updateSalaryType: false,
  salary_local_currency: '',
  englishProficiency: null,
  availability_type: null,
  starts_in_weeks: -1,
  yearsOfExperience: null,
  yearsOfWorkingRemotely: 0,
  current_availability_status: '',
  skillEditorData: {},
  expErr: false,
  education_info: [],
  cloud_certification_types: [],
  cloudCertificates: [],
  expUpdate: false,
  developerAvailabilityStatuses: {},
  allowedAvailabilityIds: [],
  baseCountryList: [],
  basicInfoError: false,
  inStackDemandSkillIds: [],
  availability_answer: null,
  showNoticeQuestion: true,
  githubUrl: '',
  githubErr: false,
  basicInfoPageSectionConfig: {
    name: { error: false, firstName: false, lastName: false },
    country: { error: false, country_residence: false, country_citizenship: false },
    phone: { error: false, phone: false },
    experience: { error: false, yearsOfExperience: false },
    yearsOfWorkingRemotely: { error: false },
    communication: { error: false, englishProficiency: false },
    availabilityType: { error: false, availability_type: false }, // Full time or partime job
    availabilityDuration: { error: false, starts_in_weeks: false },
    availabilityAnswer: { error: false, availability_answer: false },
    jobRoles: { error: false, preferred_role: false },
    salary: { error: false, preferred_salary: false },
    skills: { error: false },
    education: { error: false },
    gender: { error: false },
    ref_options: { error: false },
    others_value: { error: false },
    skillErr: false
  }
};

function BasicProfileReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {
    case BasicProfileAction.FETCH_USER_SALARY_TYPE_SUCCESS: {
      return { ...state, salaryType: payload };
    }

    case BasicProfileAction.FETCH_USER_SALARY_TYPE_FAIL:
    case BasicProfileAction.FETCH_BASIC_INFO_FAIL:
    case BasicProfileAction.FETCH_DEVELOPER_AVAILABILITY_STATUS_FAIL:
    case BasicProfileAction.FETCH_JOB_ROLE_TYPE_FAIL:
    case BasicProfileAction.FETCH_ALL_COUNTRIES_FAIL:
    case BasicProfileAction.POST_UPDATE_STATE_DATA_FAIL:
    case BasicProfileAction.POST_UPDATE_STATE_DATA_SUCCESS:
    case BasicProfileAction.FETCH_EDUCATION_FAIL:
    case BasicProfileAction.FETCH_CLOUD_CERTIFICATE_TYPES_FAIL:
    case BasicProfileAction.FETCH_USER_CLOUD_CERTIFICATE_FAIL:
    case BasicProfileAction.FETCH_CURRENCY_RATE_DATA_FAIL: {
      return { ...state };
    }

    case BasicProfileAction.REQUEST_LOADING: {
      return { ...state, loading: payload };
    }
    case BasicProfileAction.FORM_SUBMITTING: {
      return { ...state, formSubmitting: payload }
    }
    case BasicProfileAction.FETCH_ALL_COUNTRIES_SUCCESS: {
      return { ...state, baseCountryList: payload || [] };
    }
    case BasicProfileAction.FETCH_DEVELOPER_AVAILABILITY_STATUS_SUCCESS: {
      return { ...state, developerAvailabilityStatuses: payload.developerAvailabilityStatuses || {}, allowedAvailabilityIds: payload.allowedAvailabilityIds || [] };
    }
    case BasicProfileAction.FETCH_BASIC_INFO_SUCCESS: {
      const salaryType = state.salaryType;
      let updateSalaryType = state.updateSalaryType;
      let { expected_salary, expected_salary_amount_yearly } = payload;
      if (parseFloat(salaryType) === SALARY_TYPES.HOURLY) {
        updateSalaryType = true;
        expected_salary = parseInt(expected_salary, 10) * 160 * 12;
        expected_salary_amount_yearly = parseInt(expected_salary_amount_yearly, 10) * 160 * 12;
      } else if (parseInt(salaryType, 10) === SALARY_TYPES.MONTHLY) {
        expected_salary = parseInt(expected_salary, 10) * 12;
        updateSalaryType = true;
        expected_salary_amount_yearly = parseInt(expected_salary_amount_yearly, 10) * 12;
      }
      return { ...state, ...payload, expected_salary, expected_salary_amount_yearly, salaryType: 3, updateSalaryType };
    }
    case BasicProfileAction.FETCH_JOB_ROLE_TYPE_SUCCESS: {
      return { ...state, jobRoles: payload };
    }
    case BasicProfileAction.UPDATE_STATE_DATA: {
      return { ...state, ...payload };
    }
    case BasicProfileAction.FETCH_CURRENCY_RATE_DATA_SUCCESS: {
      return { ...state, ...payload };
    }
    case BasicProfileAction.FETCH_EDUCATION_SUCCESS: {
      return { ...state, education_info: payload };
    }
    case BasicProfileAction.FETCH_CLOUD_CERTIFICATE_TYPES_SUCCESS: {
      return { ...state, cloud_certification_types: payload };
    }
    case BasicProfileAction.FETCH_USER_CLOUD_CERTIFICATE_SUCCESS: {
      return { ...state, cloudCertificates: payload };
    }
    case BasicProfileAction.CLEAR_ALL_ERRORS: {
      return { ...state, basicInfoError: false, basicInfoPageSectionConfig: initialState.basicInfoPageSectionConfig };
    }
    case BasicProfileAction.RESET_STORE: {
      return { ...initialState, rate_config: state.rate_config, rate_config_date: state.rate_config_date };
    }
    default:
      return state;
  }
}

export default BasicProfileReducer;
